// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-SeoHeaderWithBreadcrumb-module__breadcrumbs__upQne";
var _2 = "assets-js-GalleryPB-SeoHeaderWithBreadcrumb-module__content__x_W2t";
var _3 = "assets-js-GalleryPB-SeoHeaderWithBreadcrumb-module__copyWrapper__hS63y";
var _4 = "assets-js-GalleryPB-SeoHeaderWithBreadcrumb-module__wrapper__GseNk";
export { _1 as "breadcrumbs", _2 as "content", _3 as "copyWrapper", _4 as "wrapper" }
